import awards from "../../shared/us.awards";
import branded_quotes from "../../shared/us.branded_quotes";
import verticals from "./us-education-homeschool-seo.verticals";

const pageFooter = ({ strings }) => {
    return {
        awards: {
            visible: true,
            title: {
                content: strings.awards_header_label,
                align: "center",
                type: "section-title"
            },
            panels: awards({ strings })
        },
        branded_quotes: {
            visible: true,
            title: {
                content: strings.branded_quotes_header_label,
                align: "center",
                type: "section-title"
            },
            panels: branded_quotes({ strings })
        },
        verticals: {
            visible: true,
            title: {
                content: strings.verticals_label,
                align: "center",
                type: "section-title"
            },
            panels: verticals({ strings })
        }
    };
};

export default ({ page, strings }) => {
    switch (page) {
        case "us-education-homeschool-seo-404":
            return {
                page,
                helmet: {
                    meta_title: "Page Not Found | Rosetta Stone",
                    meta_description: "",
                    canonical_url: "https://www.rosettastone.com/homeschool/404",
                    lang: "en"
                },
                ...pageFooter({ strings })
            };
        case "us-education-homeschool-seo-basic":
            return {
                page,
                helmet: {
                    meta_title: "Homeschool Curriculum | Rosetta Stone® Homeschool",
                    meta_description:
                        "Rosetta Stone® Homeschool is the #1 language-learning tool for homeschooling. Add English to your homeschoolers language arts curriculum & lesson plans!",
                    canonical_url: "https://www.rosettastone.com/homeschool/",
                    trustpilot: true,
                    lang: "en"
                },
                ...pageFooter({ strings })
            };
        default:
            return null;
    }
};
